import { useState } from "react";
import { RefinementList } from "react-instantsearch";
import { useDeviceType } from "../../hooks/ui";
import { Filter, X } from "lucide-react";
import { CustomRangeInput } from "./CustomRangeInput";
import { maskCurrencyWithoutCents, maskMileage } from "../../utils/common";
import { CustomRefinementList } from "./CustomRefinementList";

export const FilterItems = () => {
  const [collapsed, setCollapsed] = useState<boolean>(true);
  const { isMobile } = useDeviceType();

  const handleToggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const refinementListItems = [
    {
      attribute: "make",
      label: "Marcas",
    },
    {
      attribute: "model",
      label: "Modelos",
    },
    {
      attribute: "category",
      label: "Categorias",
    },
    {
      attribute: "city",
      label: "Cidades",
    },
  ];

  return (
    <div className="md:w-[20%] w-full max-w-64">
      <button
        className="md:hidden flex items-center justify-center gap-1 border-b-[1px]"
        onClick={handleToggleCollapsed}
      >
        <Filter size={18} />
        <span>Filtros</span>
      </button>
      <div
        className={`${isMobile ? "absolute top-0 left-0 right-0 bottom-0 bg-white z-50 px-5 py-10" : ""} transition-all duration-300 ease-in-out transform $${isMobile && !collapsed ? "hidden" : isMobile && collapsed ? "absolute top-0 left-0 right-0 bottom-0 bg-white z-50 px-5 py-10" : ""} ${
          isMobile && collapsed ? "translate-x-full" : "translate-x-0"
        }`}
        style={{
          transitionProperty: "transform",
        }}
      >
        <div className="relative w-full">
          <button
            className="md:hidden absolute right-0 -top-2"
            onClick={handleToggleCollapsed}
          >
            <X />
          </button>
        </div>

        {refinementListItems.map((item, index) => {
          return (
            <div
              key={`${item.attribute}-${item.label}-${index}`}
              className="flex flex-col mb-10"
            >
              <h3 className="text-xl font-semibold">{item.label}</h3>
              <CustomRefinementList attribute={item.attribute} />
            </div>
          );
        })}

        <CustomRangeInput
          filterLabel="Faixa de KM"
          attribute="kilometers"
          mask={maskMileage}
        />

        <CustomRangeInput
          filterLabel="Faixa de preço"
          attribute="price"
          mask={maskCurrencyWithoutCents}
        />
      </div>
    </div>
  );
};
